import React, { useState, useEffect } from "react";
import "./CourseSyllabus.css";
import Popupboxx from "../Popupbox/Popupbox";
import AOS from "aos";
import "aos/dist/aos.css";

const modules = [
  {
    title: "Fundamentals of HTML, CSS, and Adaptive Web Design",
    points: [
      "HTML: Defines the structure and content of a webpage",
      "CSS: Styles and enhances the visual presentation of HTML elements",
      "JavaScript: Adds interactivity and dynamic behavior to web pages",
      "Bootstrap: A CSS framework for responsive and mobile-first web design",
      "React: A JavaScript library for building dynamic and component-based user interfaces"
    ],
  },
  {
    title: "React: A JavaScript library for building dynamic and component-based user interfaces",
    points: [
      "OOP Concepts: Principles like encapsulation, inheritance, polymorphism, and abstraction for structured programming",
      "Data Types: Defines the type of data a variable can hold, including primitive and non-primitive types",
      "Loops: Control structures (for, while, do-while) used for executing repetitive tasks",
      "Exception Handling: Mechanism to handle runtime errors using try, catch, throw, and finally blocks"
    ],
  },
  {
    title: "Fundamentals of Advanced Java: Multithreading, Exception Handling, JDBC, and Servlets & JSP",
    points: [
      "Multithreading: Enables concurrent execution of multiple threads to improve performance",
      "Exception Handling: Manages runtime errors using try, catch, throw, and finally blocks",
      "JDBC: Java Database Connectivity for interacting with relational databases",
      "Servlets & JSP: Used for building dynamic web applications in Java",

    ],

  },
  {
    title: "Fundamentals of Java Web Development: Servlets, JSP, Spring Boot, and Hibernate ORM",
    points: [
      "Java Servlets & JSP: Technologies for building dynamic web applications using Java",
      "Spring Boot Framework: A Java framework for creating standalone, production-ready applications with minimal configuration",
      "Hibernate ORM: A framework for mapping Java objects to relational database tables for efficient data management",

    ],

  },
  {
    title: "IFundamentals of Databases: SQL and MongoDB",
    points: [
      "SQL: Used for managing relational databases with queries, joins, and stored procedures",
      "MongoDB: A NoSQL database for handling flexible and scalable data storage",

    ],

  },
  {
    title: "Fundamentals of DevOps and Version Control",
    points: [
      "Git & GitHub: Tools for version control and collaborative development.",
      "Maven: A build automation tool for Java projects.",
      "Postman: A tool for API testing and development.",
      "Docker: A platform for containerizing applications.",
      "Jenkins: A CI/CD automation server for software development."
    ],
  },

  {
    title: "Fundamentals of Project Development",
    points: [
      "Project Development: Hands-on experience through mini projects and a capstone project.",
      "Real-World Application: Implementing learned technologies to build functional software solutions.",
      "Team Collaboration: Working in teams to simulate industry-level project development workflows."
    ],
  },

  {
    title: "Fundamentals of Full-Stack Integration",
    points: [
      "Full-Stack Integration: Combining frontend, backend, and database for complete application development.",
      "Seamless Connectivity: Ensuring smooth communication between client-side and server-side components.",
      "Deployment & Optimization: Deploying applications with performance tuning and security best practices."
    ],
  },

  {
    title: "Employment Readiness and Career Abilities",
    points: [
      "Technical Interview Drills: Practice with professional feedback.",
      "Resume & Portfolio Development: Build standout resumes and showcase projects on GitHub to attract recruiters.",
      "Soft Skills Enhancement: Master communication and presentation skills to excel in interviews.",
      "Career Opportunities: Placement support connects students with top hiring companies."
    ],
  },
];

function CourseSyllabus() {
  const [activeModule, setActiveModule] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  // Detect screen size
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize(); // check on load
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <>
      <section className="syllabus-section">
        <div className="container">
          <div className="headlines-for-all">
            <h4 data-aos="fade-up">
              <span>Course </span> Syllabus
            </h4>
            <p data-aos="fade-up">
              Explore our comprehensive Java Full Stack syllabus — built for
              real-world projects, hands-on learning, and 100% job readiness.
            </p>
          </div>


          {/* ---------- Desktop Tabs ---------- */}
          {!isMobile && (
            <>
              <div className="custom-btn-group " data-aos="fade-up">
                {modules.map((m, index) => (
                  <button
                    key={index}
                    className={`custom-btn ${activeModule === index ? "active" : ""
                      }`}
                    onClick={() => setActiveModule(index)}
                  >
                    Module {index + 1}
                  </button>
                ))}
              </div>

              <div className="custom-module-container" data-aos="fade-up">
                <div className="custom-module-box active">
                  <h4>{modules[activeModule].title}</h4>
                  <ul className="ul-list-module">
                    {modules[activeModule].points.map((p, i) => (
                      <li key={i}>{p}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </>
          )}

          {/* ---------- Mobile Accordion (FAQ Style) ---------- */}
          {isMobile && (
            <div className="faq-container-course" data-aos="fade-up">
              {modules.map((m, index) => (
                <div
                  key={index}
                  className={`faq-item-course ${activeModule === index ? "open" : ""
                    }`}
                >
                  <button
                    className="faq-question-course"
                    onClick={() =>
                      setActiveModule(activeModule === index ? null : index)
                    }
                  >
                    {m.title}
                    <span className="faq-icon-course">
                      {activeModule === index ? "−" : "+"}
                    </span>
                  </button>

                  <div
                    className="faq-answer-course"
                    style={{
                      maxHeight: activeModule === index ? "400px" : "0px",
                    }}
                  >
                    <ul>
                      {m.points.map((p, i) => (
                        <li key={i}>{p}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          )}

          <div className="btn-center" data-aos="fade-up">
            <button className="download-btn" onClick={() => setIsPopupOpen(true)}>Download Syllabus</button>
          </div>
        </div>
      </section>


      <Popupboxx
        isOpen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
      />
    </>
  );
}

export default CourseSyllabus;
